var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"ak-question-answer",on:{"click":_vm.selectAnswer}},[(_vm.isUserSelected)?_c('mdicon',{staticClass:"ak-icon user-select",attrs:{"name":"AccountCircle","size":"26"}}):_vm._e(),_vm._v(" "+_vm._s(_vm.text)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }